import React from "react";
import { InputText } from "primereact/inputtext";
import classNames from "classnames";

function ZbizInput({ onChange, values, isFormFieldValid, getFormErrorMessage, keyName, placeholder, type, disabled, required, label }) {
    return (
        <>
            <label htmlFor={keyName} className={classNames({ "p-error": isFormFieldValid(keyName.toString()) }, "Label__Text")}>
                {label} {required && <span className="Label__Required">*</span>}
            </label>
            <InputText id={keyName} type={type ? type : "text"} disabled={disabled ? disabled : false} placeholder={placeholder || ""} name={keyName} value={values[keyName]} onChange={onChange} className={classNames({ "p-invalid": isFormFieldValid(keyName.toString()) }, "Input__Round")} />
            {getFormErrorMessage(keyName.toString())}
        </>
    );
}

export default ZbizInput;
